import { useState, useEffect, useCallback } from 'react';
import supabase, { orgId } from '../supabaseClient';

const SETTINGS_KEY = 'cash_settings';

export function defaultCashSettings() {
  return {
    openingCash: '',
    platformTerms: {},
    platformMonthly: {},
    devAdvTerms: {},
    devAdvMonthly: {},
    pubCostsPct: { 0: '100', 1: '0', 2: '0' },
    pubCostsMonthlyPct: {},
    royaltyTerms: {},
    royaltyMonthly: {},
    royaltyQuarterly: {},
    royaltyQuarterStart: {},
    payrollPct: '100',
  };
}

export default function useCashSettings() {
  const [settings, setSettings] = useState(defaultCashSettings);
  const [loaded, setLoaded]     = useState(false);

  useEffect(() => {
    supabase.from('app_settings').select('value')
      .eq('org_id', orgId).eq('key', SETTINGS_KEY).maybeSingle()
      .then(({ data }) => {
        if (data?.value) {
          try { setSettings({ ...defaultCashSettings(), ...JSON.parse(data.value) }); } catch (_) {}
        }
        setLoaded(true);
      });
  }, []);

  const save = useCallback((updater) => {
    setSettings(prev => {
      const next = typeof updater === 'function' ? updater(prev) : updater;
      supabase.from('app_settings')
        .upsert({ org_id: orgId, key: SETTINGS_KEY, value: JSON.stringify(next) }, { onConflict: 'org_id,key' })
        .then(null, e => console.error('[cash settings]', e));
      return next;
    });
  }, []);

  return { settings, save, loaded };
}
